import { render, staticRenderFns } from "./case-add.vue?vue&type=template&id=1550f2b0&scoped=true"
import script from "./case-add.vue?vue&type=script&lang=js"
export * from "./case-add.vue?vue&type=script&lang=js"
import style0 from "./case-add.vue?vue&type=style&index=0&id=1550f2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1550f2b0",
  null
  
)

export default component.exports